// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__TKD1W","center":"Loading_center__cF02i","img":"Loading_img__2U5vA","text":"Loading_text__EcJcH","subtext":"Loading_subtext__ZHE9d"};